import type { ChatMessageSummaryBasicInfoAllOf } from './chatMessageSummaryBasicInfoAllOf';
import type { ChatMessageSummaryBasicInfoAllOfTwo } from './chatMessageSummaryBasicInfoAllOfTwo';

export type ChatMessageSummaryBasicInfo = ChatMessageSummaryBasicInfoAllOf & ChatMessageSummaryBasicInfoAllOfTwo;
